export default "__VITE_ASSET__C$S26bOk__"